// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"cab0af10","79":"745f75de","735":"fe9fb910"}[chunkId] + ".chunk.js";
};